import { Component, OnInit, Input } from '@angular/core';
import { WidgetApplicationDetailsDTO } from 'src/app/core/models/system/widget/widget-application-details.dto';

@Component({
  selector: 'app-application-usage-summary',
  templateUrl: './application-usage-summary.component.html',
  styleUrls: ['./application-usage-summary.component.scss']
})

export class ApplicationUsageSummaryComponent implements OnInit {
  
  @Input() applicationUsageSummary: WidgetApplicationDetailsDTO[] | undefined;

  constructor() { }

  public ngOnInit(): void { }
}
